import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import './registerServiceWorker'
import router from './router';
import VAnimateCss from 'v-animate-css';
import VueQrcodeReader from "vue-qrcode-reader";
import DatetimePicker from 'vuetify-datetime-picker';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import "./plugins/vuetify-mask.js";

Vue.config.productionTip = false;

Vue.use(VAnimateCss);
Vue.use(VueQrcodeReader);
Vue.use(DatetimePicker);
Vue.use(Loading, {
  'canCancel': false,
  'background-color': '#000',
  'color': '#172349',
  'loader': 'bars',
})

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
